import { render } from "./RecoveryPageV2.vue?vue&type=template&id=5ce8a794&scoped=true"
import script from "./RecoveryPageV2.vue?vue&type=script&lang=js"
export * from "./RecoveryPageV2.vue?vue&type=script&lang=js"

import "./RecoveryPageV2.vue?vue&type=style&index=0&id=5ce8a794&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce8a794"]])

export default __exports__